import script from "./ConversationMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationMessage.vue?vue&type=script&setup=true&lang=ts"

export default script